/*@flow*/
import type { Node, Element } from 'react';
import React from 'react';
import ResourceFormOpener from 'comps/ResourceBuilder/ResourceForm/Link';
import * as I from 'immutable';
import useCachedQuery from 'lib/useCachedQuery';
import NonEmptyArray from 'lib/NonEmptyArray';
import gql from 'graphql-tag';
import type { DocumentNode } from 'graphql';
import cx from 'classnames';

const GET_ASSET = (gql(`
  query getAsset($streetscapeAssetId: ID!) {
    me {
      id
      company {
        id
        streetscapeAsset(id: $streetscapeAssetId) {
          theGeom
        }
      }
    }
  }
`): DocumentNode);

type Props = {
  streetscapeAssetId: ID,
  title: string,
  className: string,
};

export default (props: Props): Node | Element<'span'> => {
  const { data, loading, errors } = useCachedQuery(GET_ASSET, {
    variables: { streetscapeAssetId: props.streetscapeAssetId },
  });
  const theGeom = I.getIn(data, [
    'me',
    'company',
    'streetscapeAsset',
    'theGeom',
  ]);
  if (NonEmptyArray.is(errors)) { return <span>{errors.map((v) => v.error)}</span>; }

  return (
    <ResourceFormOpener
      id={null}
      className={props.className}
      resourceName="StreetscapeIssue"
      title={props.title}
      resource={{
        streetscapeAssetId: props.streetscapeAssetId,
        theGeom,
        status: 'Open',
      }}
    >
      <i
        className={cx('fa', {
          'fa-exclamation-triangle': !loading,
          'fa-spinner fa-spin': loading,
        })}
      />{' '}
      Create Issue
    </ResourceFormOpener>
  );
};
